























import { Component, Model, Vue } from 'vue-property-decorator';
import { TotalActivity } from '@luxtag/papybase';
import { map } from 'lodash';

@Component
export default class TotalActivityChart extends Vue {
    @Model('update:returnValue', {}) readonly value!: TotalActivity[];

    get titles() {
        return map(this.value, a => a.title);
    }

    get counts() {
        return map(this.value, a => a.count);
    }
}
